import emojiRegex from "emoji-regex";

export const alphabetsWithSpaceRegex = /^[a-zA-Z\s]+$/;
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{6,}$/;
export const extraSpacesRegex = /[^\S\n]+/g;
const alphaUnderscoreSpaceRegex = /^[a-zA-Z_\-\s]+$/;
const emojiregex = emojiRegex()
const alphaNumericUnderscoreSpaceRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9_.-]+$/
const alphanumericWithSpecialCharPatternWithSpace = /^(?=.*[a-zA-Z])[A-Za-z0-9!@#$%^&*(),.?":{}|<>_ -]+$/;
const alphanumericWithSpaceRegex = /^(?:[a-zA-Z]+(?: [a-zA-Z]+)*|[a-zA-Z][a-zA-Z0-9]*(?: [a-zA-Z0-9]+)*)$/
const htmlTagsRegex = {
    test: function (str) {
        if (!str || typeof str !== 'string') return false;
        let inTag = false;
        for (const char of str) {
            if (char === '<') {
                inTag = true;
            } else if (char === '>' && inTag) {
                return true;
            }
        }
        return false;
    }
};
export const validateContentRules = (_, value) => {
    const emojiregex = emojiRegex()
    if (value && (htmlTagsRegex.test(value) || value.match(emojiregex))) {
        return Promise.reject("Please enter valid content");
    }
    return Promise.resolve();
}

export const regexMap = {
    onlyAlphaWithSpace: alphabetsWithSpaceRegex,
};

export const validations = {
    requiredValidator: (required = true, message = 'Is required') => {
        return {
            required: required,
            message: message
        };
    },
    alphaUnderscoreSpaceValidator: (fieldName) => {
        return {
            pattern: alphaUnderscoreSpaceRegex,
            message: `Invalid ${fieldName}`,
        };
    },
    textValidator: (fieldName, validOn = 'onlyAlphaWithSpace', allowOnly = []) => {
        return () => ({
            validator(_, value) {
                const valueToValidate = value ? value.trim() : value;
                if (!valueToValidate) {
                    return Promise.resolve();
                }

                const invalid = !regexMap[validOn]?.test(valueToValidate);

                if (invalid) {
                    return Promise.reject(new Error(`Invalid ${fieldName}`));
                }

                return Promise.resolve();
            }
        });
    },
};

export const userValidationRules = {
    alphanumeric: [
        { required: true, message: "Mandatory field", validateTrigger: "onBlur" },
        {
            pattern: /^(?=.*[a-zA-Z])[\w!@#$%^&*(),.?":{}|<>-]+$/,
            message: "Accepts alphanumeric and special chars.",
            validateTrigger: "onBlur",
        }
    ],
    password: [
        { required: true, message: "Mandatory field" },
        {
            pattern: /^(?=.*[a-zA-Z])[\w!@#$%^&*(),.?":{}|<>-]+$/,
            message: "Invalid Password.",
            validateTrigger: "onBlur",
        }
    ],
    phone: [
        { pattern: /^\d{10}$/, message: "Invalid mobile number.", validateTrigger: "onBlur" }
    ],
    email: [
        { required: true, message: "Mandatory field" },
        {
            type: "email",
            message: "Invalid Email Address",
            validateTrigger: "onBlur",
        }
    ]
};
export const passwordValidation = (_, value) => {
    if (!value) {
        return Promise.resolve();
    }
    if (value.length < 8) {
        return Promise.reject("Password must be at least 8 characters.");
    }
    if (!passwordRegex.test(value)) {
        return Promise.reject("Invalid password.");
    }
    if (htmlTagsRegex.test(value)) {
        return Promise.reject("Invalid password.");
    }
    if (value.match(emojiregex)) {
        return Promise.reject("Invalid password.");
    }
    return Promise.resolve();
};
export const containsHtmlOrEmoji = (value) => {
    if (!value) return false; // No value means no issue
    const emojiregex = emojiRegex()
    const alphanumeric = /^[A-Za-z0-9@#$%&_ -]+$/

    return htmlTagsRegex.test(value) || emojiregex.test(value) || !alphanumeric.test(value);
};
export const validateNoHtmlOrEmoji = (_, value) => {
    if (containsHtmlOrEmoji(value)) {
        return Promise.reject(`Invalid role name.`);
    }
    if (!alphaNumericUnderscoreSpaceRegex.test(value)) {
        return Promise.reject(`Invalid role name.`);
    }
    return Promise.resolve();
};

export const alphanumericPattern = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?\s]+$/;

export const replaceExtraSpaces = (value) => {
    if (value && typeof value === 'string') {
        return value.replace(extraSpacesRegex, ' ').trim()
    }
    return value
}
export const validateAlphanumericWithSpecialChar = (fieldName) => (_, value) => {
    if (!value) return Promise.resolve();
    if (value.length < 3) {
        return Promise.reject(`Invalid ${fieldName}.`);
    }
    if (!alphanumericWithSpecialCharPatternWithSpace.test(value) || htmlTagsRegex.test(value) || emojiregex.test(value)) {
        return Promise.reject(`Invalid ${fieldName}.`);
    }
    return Promise.resolve();
};
export const validateAlphanumericWithSpace = (fieldName) => (_, value) => {
    if (!value) return Promise.resolve();
    if (value.length < 3) {
        return Promise.reject(`Invalid ${fieldName}.`);
    }
    if (!alphanumericWithSpaceRegex.test(value) || emojiregex.test(value)) {
        return Promise.reject(`Invalid ${fieldName}.`);
    }
    return Promise.resolve();
};
export const validateTRXHash = (_, value) => {
    if (value && !/^[a-fA-F0-9]{64}$/.test(value)) {
        return Promise.reject(new Error('Hash must be 64 hexadecimal characters.'));
    }
    return Promise.resolve();
};
export const validateTronAddressOrHash = (_, value) => {
    const trxHashRegex = /^[A-Fa-f0-9]{64}$/;
    const tronAddressRegex = /^T[a-zA-Z0-9]{33}$/;

    if (!value) {
        return Promise.resolve();
    }

    if (trxHashRegex.test(value) || tronAddressRegex.test(value)) {
        return Promise.resolve();
    }

    return Promise.reject(new Error('Invalid hash.'));
};
